export default __webpack_public_path__ + "static/media/Priest's Belt of the Black Thread.562476d0.jpg";